import Service from './Service';

const CALLBACKSERVICE_SETDATA = 'CALLBACKSERVICE_SETDATA';
const CALLBACKSERVICE_SET = 'CALLBACKSERVICE_SET';

const reducerName = 'callback';
const initialState = {
    times: [],
    selected: '',
    phone: '',
    phoneType: '',
    useMilitary: false,
    timezone: 'CT'
};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case CALLBACKSERVICE_SETDATA:
            return {
                ...state,
                ...payload
            };
        case CALLBACKSERVICE_SET: {
            const {key, value} = payload;
            return {
                ...state,
                [key]: value
            };
        }
    }
    return state;
};

class CallbackService extends Service {
    constructor() {
        super();

        if (!CallbackService.instance) {
            CallbackService.instance = this;
        }
        return CallbackService.instance;
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    setData(data) {
        this.store.dispatch({
            type: CALLBACKSERVICE_SETDATA,
            payload: data
        });
    }

    set(key, value) {
        this.store.dispatch({
            type: CALLBACKSERVICE_SET,
            payload: {key, value}
        });
    }

    getDataForSave() {
        const callback = {...this.getReducerState()};
        delete callback.times;
        if (callback.phoneType === 'none') {
            delete callback.phoneType;
        }
        return callback;
    }
}

export default new CallbackService();
